import React from 'react';
import { graphql } from 'gatsby';

import BlockContentLargeSectionDS from 'design-system/src/components/organisms/BlockContentLargeSection';

import { BlockContent } from '../../models/block-content';
import { getImage } from '../../utils/media';

interface BlockContentLargeSectionProps {
    blockContent: BlockContent[];
}

export default function BlockContentLargeSection({
    blockContent,
}: BlockContentLargeSectionProps) {
    return blockContent?.map(({ id, image, ...blockProps }) => {
        return (
            <BlockContentLargeSectionDS
                key={`block-content-${id}`}
                {...(!!image && { image: getImage(image) })}
                {...blockProps}
            />
        );
    });
}

export const query = graphql`
    fragment DatoCmsBlockContentLargeSection on DatoCmsBlockContentLargeSection {
        blockContent {
            id
            preTitle
            preTitleTag
            title
            titleTag
            description
            descriptionLarge
            image {
                ...SourceMedia
                gatsbyImageData(width: 1250, placeholder: BLURRED)
            }
            imageRight
            imageWithFrame
            imageRounded
            iframeUrl
            cta {
                ...Button
            }
        }
    }
`;
